import React, { ComponentType, FunctionComponent } from 'react';
import { RouteProvider } from './RouteProvider';

export function withRouteProvider<Props = any>() {
  return (WrappedComponent: ComponentType) => {
    const WithRouteProvider: FunctionComponent<Props> = props => (
      <RouteProvider {...props}>
        <WrappedComponent {...props} />
      </RouteProvider>
    );

    return WithRouteProvider;
  };
}
